// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","primary":"#492172","footer":"_2nhz","white":"_16q8","linksTitle":"_3rCm","link":"NoJN","logo":"_1W3u","bfo":"_2ldF","badge":"_28Dc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Footer.scss
// module id = LeO/
// module chunks = 0